import axios from "axios";
import regenerateToken from "../components/Configurations/regenerateTokens";

export function setupAuthInterceptor() {
  if (window.__authInterceptorInstalled) {
    return;
  }

  // State for token refresh queue
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };

  const handle401 = async (originalRequest, successResponseObj, errorObj) => {
    if (originalRequest._retry) {
      if (successResponseObj) return successResponseObj;
      return Promise.reject(errorObj);
    }
    
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          if (originalRequest.headers) {
            originalRequest.headers["authorization"] = token;
          }
          return axios(originalRequest);
        })
        .catch((err) => {
          if (successResponseObj) return successResponseObj;
          return Promise.reject(err);
        });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const newToken = await regenerateToken();
      if (originalRequest.headers) {
        originalRequest.headers["authorization"] = newToken;
      }
      processQueue(null, newToken);
      return await axios(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);
      // Refresh failed (e.g., refresh token expired)
      console.error("Refresh token failed, logging out:", refreshError);
      localStorage.removeItem("idTokenBilling");
      localStorage.removeItem("loginDetails");
      
      // Redirect to login if user isn't already there
      if (window.location.pathname !== "/login") {
         window.location.href = "/login";
      }

      if (successResponseObj) return successResponseObj;
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  };

  axios.interceptors.response.use(
    async (response) => {
      const originalRequest = response.config;
      // Some components use validateStatus to treat 401 as a success response.
      // We must catch those here.
      if (
        response && 
        response.status === 401 && 
        originalRequest &&
        originalRequest.url !== "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/oauth/token?grant_type=refresh_token"
      ) {
         return handle401(originalRequest, response, null);
      }
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        originalRequest &&
        originalRequest.url !== "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/oauth/token?grant_type=refresh_token"
      ) {
         return handle401(originalRequest, null, error);
      }
      return Promise.reject(error);
    }
  );

  window.__authInterceptorInstalled = true;
}
